import { render, staticRenderFns } from "./DetectionDetailDefaultLayout.vue?vue&type=template&id=8782a470&scoped=true"
import script from "./DetectionDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./DetectionDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8782a470",
  null
  
)

export default component.exports